module.exports = __webpack_public_path__ + "assets/img/coupon.56b62c9e.png";